import { useMediaQuery, useTheme } from '@material-ui/core';
import { PanelResizeHandle } from 'react-resizable-panels';

export const ResizeHandle = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  if (isMobile) {
    return null;
  }
  return (
    <PanelResizeHandle
      hitAreaMargins={{ coarse: 15, fine: 5 }}
      className="w-[2px] h-full bg-gray-200 data-[resize-handle-state=hover]:bg-gray-500 data-[resize-handle-state=drag]:bg-gray-500 cursor-col-resize"
    />
  );
};
